import React from "react";
import ReactDOM from "react-dom/client";
// Grid only (containers and layout utilities); the full Bootstrap stylesheet
// would reset fonts, links and buttons.
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { registerServiceWorker } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
